import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from '../../../Core/Store/store';
import { userLogin } from './auth.api';
import { IAuth } from './auth.interface';
import CryptoJS from 'crypto-js';
//initial state for auth info
const getInitialState = (): IAuth => {
  const token = localStorage.getItem('token');
  const roleEncrypted = localStorage.getItem('role');
  let role = '';

  if (roleEncrypted) {
    const secretKey = process.env.REACT_APP_SECRET_KEY;
    const bytes = CryptoJS.AES.decrypt(roleEncrypted, secretKey);
    role = bytes.toString(CryptoJS.enc.Utf8);
  }

  if (token) {
    // Optionally, parse token if needed
    // assuming token is stored as JSON string
    const tokenData = JSON.parse(token);
    return {
      token: tokenData.access_token,
      name: tokenData.name || '',
      role: role,
      isAuth: true,
    };
  }

  return {
    token: '',
    name: '',
    role: role,
    isAuth: false,
  };
};

const initialState: IAuth = getInitialState();

export const fetchLogin = createAsyncThunk('users/fetchByIdStatus', async (userData: any) => {
  const response = await userLogin(userData);
  return response.data;
});

/**
 * @todo
 * create my reducer && set actions to it
 *
 */
export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    // when sign in get my data to my reducer
    signIn: (state, action) => {
      localStorage.setItem('token', JSON.stringify(action.payload));
      console.log(action);
        const secretKey = process.env.REACT_APP_SECRET_KEY;
    const encryptedRole = localStorage.getItem('role');

    if (encryptedRole) {
      const bytes = CryptoJS.AES.decrypt(encryptedRole, secretKey);
      const decryptedRole = bytes.toString(CryptoJS.enc.Utf8);
      state.role = decryptedRole;
    }
      state.isAuth = true;
      state.token = action.payload.access_token;
    },
    // when sign out return my state to initial state
    signOut: () => {
      return initialState;
    },
  },
});

// export my actions to dispatch hook
export const { signIn, signOut } = authSlice.actions;

// get my auth object from my selector hook
export const selectAuth = (state: RootState) => state.auth;

// export reducer to my state
export default authSlice.reducer;
